const API_BASE = process.env.REACT_APP_API_URL || "https://api.eazy-billing.com";
export default API_BASE;
